let PackagesItem = [
	{
		track: 'Junior',
		trackJunior: true,
		trackTitle: 'Junior Track',
		trackSubtitle: true,
		trackPrice: '0',
		runningString: true,
		trackButton: 'Register',
		trackLink: 'https://geekle.us/ticketfree/1721343900446x699059230841765900',
		// juniorTicket1Name: "Free Ticket",
		// juniorTicket1Price: "0.00",
		// juniorTicket1Link: "https://geekle.us/ticketfree/1684419531109x998420949885255700",
		// juniorTicket2Name: "+ Certificate",
		// juniorTicket2Price: "9.99",
		// juniorTicket2Link: "https://geekle.us/ticket/1699051262272x434038936238293000",
		// juniorTicket3Name: "+ Certificate & Recordings",
		// juniorTicket3Price: "15.99",
		// juniorTicket3Link: "https://geekle.us/ticket/1699052276762x800257793798176800",
	},
	{
		track: 'Full Access',
		trackFull: true,
		trackTitle: 'FULL ACCESS 🔥',
		trackSubtitle: 'ticket',
		runningString: true,
		trackPrice: '99',
		// trackPriceOld: '199',
		// earlyBird: 'early birds price',
		trackDesc: '1',
		trackButton: 'Register',
		trackList1: 'DAY1 Access',
		trackLink: 'https://geekle.us/ticket/1721342480900x249483259732557820',
	},
	// {
	// 	track: 'Full Access',
    //     trackCombo: true,
    //     trackTitle: "JS Combo",
    //     trackSubtitle: "package",
    //     runningString: true,
    //     trackPrice: "179",
    //     // earlyBird: "early birds price",
    //     trackDesc: "1",
    //     trackButton: "Register",
    //     trackLink: 'https://geekle.us/ticket/1724658118123x628582870531440600',
    // },
	{
		track: 'Year',
		trackTitle: 'YEAR OF ARCHITECTURE ❤️',
		trackSubtitle: 'package',
		runningString: true,
		trackPrice: '249',
		// trackPriceOld: '249',
		earlyBird: 'one year access',
		trackDesc: '1',
		trackText: true,
		yearTrackText: true,
		trackText1: 'One Year Package',
		trackButton: 'Register',
		trackLink: 'https://geekle.us/ticket/1721342179231x672044432766271500',
	},
	{
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        // trackFullPrice: "399",
        trackPrice: "399",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1696847842733x949907249339039700',
        inverseColors: true,
    },
    {
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
